<div class="notifications-header">
  <mat-icon>notifications</mat-icon><h2 class="m-0 text-white">Notifications</h2>
</div>

@if (notifications().length == 0) {
  <div class="no-notifications">
    <h2>No Notifications</h2>
    <p>You don't have any notifications yet</p>
  </div>
}

<mat-nav-list class="notification-list" role="list">
  <!-- Notification item -->
  @for (notification of notifications(); track notification) {
    <mat-list-item class="notific-item" role="listitem" [routerLink]="notification.notificationRedirectRoute">
      <a matListItemTitle>{{notification.title}}</a>
      <span matListItemLine>{{notification.formatedCreatedDate}}</span>
    </mat-list-item>
  }
</mat-nav-list>
